<template>
<div class="main list-view no-sub-header">

	<div class="filters">

		<div class="section-list">
			<div class="what"><i class="fas fa-check-circle" :class="{ section_complete: sectionComplete('supplier') }"></i> Supplier</div>
			<div class="what"><i class="fas fa-check-circle" :class="{ section_complete: sectionComplete('product') }"></i> Product Info</div>
			<div class="what"><i class="fas fa-check-circle" :class="{ section_complete: sectionComplete('pricing') }"></i> Inventory / Pricing</div>
			<div class="what"><i class="fas fa-check-circle" :class="{ section_complete: sectionComplete('serialnumbers') }"></i> <span :class="productDetail.serializable ? '' : 'not-required'">Serial Numbers</span></div>
			<div class="what"><i class="fas fa-check-circle" :class="{ section_complete: sectionComplete('logbook') }"></i> <span :class="productDetail.serializable ? '' : 'not-required'">Log Book</span></div>
		</div>

		<div class="divider"></div>

		<div :class="['button', canSave() ? 'action' : 'disabled' ]" @click="receiveItem()">{{ receiveButtonLabel }}</div>
		<div class="button neutral" @click="backToList()">Back To List</div>

	</div>

	<div id="detail_receive_inventory" class="detail receive-inventory">

		<div class="main-receive-column">

			<div class="tab-content">
				<div class="tab-section-title">
					{{ supplierDetail.full_name }}
					<div v-if="this.orderDetail.order_method_code == 'PURCHASE_ORDER'" style="font-size: 0.8em; font-weight: bold;">Purchase Order {{ this.orderDetail.purchase_order_number }}</div>
				</div>
				<div class="one-two-columns">
					<div class="two-columnsz">
						<div>
							<label>Supplier Invoice #</label>
							<input type="text" v-model="supplierDetail.supplier_invoice" />
						</div>
						<div>
							<label>Freight</label>
							<number-input :decimals="2" v-model="supplierDetail.freight" :key="'freight_' + supplierDetail.freight" />
						</div>
					</div>
					<div>
						<label>Notes</label>
						<textarea v-model="supplierDetail.notes" style="height: 4em;"></textarea>
						<div v-if="inventory_receipt_id != 'new'" :class="['button', 'inline', saving ? 'disabled' : 'neutral', 'update-notes']" @click="saveInvoiceFreight()">Update Invoice / Freight / Notes</div>
					</div>
				</div>
			</div>

			<div class="tab-content">
				<div class="tab-section-title">Product Info</div>

				<product-detail-form data-v-step="5" :product="productDetail" :hideSerializable="true" :hideControls="true" :requireUPCSearch="!productDetail.new_product" :noCancel="true" @save="updateProduct" :key="'product_detail_component_' + productDetail.product_id + productDetail.new_image"></product-detail-form>

				<div class="three-columns" style="margin: 0.5em 0 1em 0;">
					<!-- <checkbox v-model="productDetail.serializable" label="Serializable" :disabled="userCannotEdit" :key="'serializable_' + productDetail.product_id + '_' + productDetail.serializable"/> -->
					<div>
						<!-- <input type="checkbox" v-model="productDetail.serializable" :disabled="userCannotEdit" :key="'serializable_' + productDetail.product_id + '_' + productDetail.serializable" /> Serializable -->
						<span v-if="userCannotEdit" :class="['far', productDetail.serializable ? 'fa-check-square' : 'fa-square']" style="font-size: 1.25em; cursor: not-allowed;"></span>
						<span v-else :class="['pointer', 'far', productDetail.serializable ? 'fa-check-square' : 'fa-square']" style="font-size: 1.25em;" @click="productDetail.serializable = !productDetail.serializable"></span>
						<label style="margin: 0 0 0 0.5em;">Serializable</label>
					</div>

					<!-- <checkbox v-model="productDetail.not_taxable" label="Not Taxable" :disabled="userCannotEdit" :key="'not_taxable_' + productDetail.product_id + '_' + productDetail.not_taxable"/> -->
					<div>
						<!-- <input type="checkbox" v-model="productDetail.not_taxable" :disabled="userCannotEdit" :key="'not_taxable_' + productDetail.product_id + '_' + productDetail.not_taxable"/> Not Taxable -->
						<span v-if="userCannotEdit" :class="['pointer', 'far', productDetail.not_taxable ? 'fa-check-square' : 'fa-square']" style="font-size: 1.25em; cursor: not-allowed;"></span>
						<span v-else :class="['far', productDetail.not_taxable ? 'fa-check-square' : 'fa-square']" style="font-size: 1.25em;" @click="productDetail.not_taxable = !productDetail.not_taxable"></span>
						<label style="margin: 0 0 0 0.5em;">Not Taxable</label>
					</div>
					<!-- <checkbox v-model="productDetail.is_hazardous" label="Hazardous" :disabled="userCannotEdit" :key="'is_hazardous' + productDetail.product_id"/> -->
					<div>
						<!-- <input type="checkbox" v-model="productDetail.is_hazardous" :disabled="userCannotEdit" :key="'is_hazardous_' + productDetail.product_id + '_' + productDetail.is_hazardous"/> Hazardous -->
						<span v-if="userCannotEdit" :class="['far', productDetail.is_hazardous ? 'fa-check-square' : 'fa-square']" style="font-size: 1.25em; cursor: not-allowed;"></span>
						<span v-else :class="['pointer', 'far', productDetail.is_hazardous ? 'fa-check-square' : 'fa-square']" style="font-size: 1.25em;" @click="productDetail.is_hazardous = !productDetail.is_hazardous"></span>
						<label style="margin: 0 0 0 0.5em;">Hazardous</label>
					</div>
				</div>

				<div class="five-columns">
					<div>
						<div class="label">Weight <span class="label">(pounds)</span></div>
						<number-input :disabled="userCannotEdit" :decimals='2' :inline="true" v-model="productDetail.ship_weight" :key="'ship_weight_' + productDetail.product_id"/>
					</div>
					<div>
						<div class="label">Length <span class="label">(inches)</span></div>
						<number-input :disabled="userCannotEdit" :decimals='2' :inline="true" v-model="productDetail.ship_length" :key="'ship_length' + productDetail.product_id"/>
					</div>
					<div>
						<div class="label">Width <span class="label">(inches)</span></div>
						<number-input :disabled="userCannotEdit" :decimals='2' :inline="true" v-model="productDetail.ship_width" :key="'ship_width' + productDetail.product_id"/>
					</div>
					<div>
						<div class="label">Height <span class="label">(inches)</span></div>
						<number-input :disabled="userCannotEdit" :decimals='2' :inline="true" v-model="productDetail.ship_height" :key="'ship_height' + productDetail.product_id"/>
					</div>
				</div>

				<div v-if="productDetail.new_product" class="controls">
					<div :class="['button', 'spaced', 'action', { disabled: !validateNewProduct || saving }]" @click="saveNewProduct()">Save New Product</div>
					<div class="button spaced cancel" @click="cancelNewProduct()">Cancel</div>
					<div v-if="saveProductMessage" class="message">{{ saveProductMessage }}</div>
				</div>

				<div v-if="productDetail.product_id && !productDetail.client_id">
					<span class="message" style="margin: 0 1em 0 0;"><i class="fas fa-ban"></i> Product info is locked for distributor products. <span style="font-size: 0.9em;"><i>You can request a product edit after receiving this item.</i></span></span>
					<span class="message"></span>
				 </div>
			</div>

			<div data-v-step="11" class="tab-content" ref="inventory_pricing">
				<div class="tab-section-title">Inventory / Pricing</div>
				<div class="sub-section four-columns align-items-start">
					<div>
						<label v-if="productDetail.serializable">Quantity Received for this serialized product is the number of Serial Numbers you enter.<br><br>Total Serial Numbers</label>
						<label-required v-else label="Quantity Received" :condition="productInventory.received" />
						<div v-if="productDetail.serializable" style="font-size: 1.25em; margin: 0.25em;">{{ enteringSeries ? serialNumberSeries.length : serialNumberCount }}</div>
						<number-input v-else data-v-step="6" :decimals="0" :disabled="productDetail.serializable || !productDetail.product_id" v-model="productInventory.received" :key="'received_' + productInventory.received"  />
					</div>
					<div>
						<label>Quantity On Hand</label>
						<number-input v-model="productInventory.on_hand" :disabled="true" :key="'on_hand_' + productInventory.on_hand" />
						<label>Distributor On Order</label>
						<number-input v-model="productInventory.on_order" :disabled="true" :key="'on_order_' + productInventory.on_order" />
					</div>
					<div>
						<label>Sold Last 30 Days</label>
						<number-input v-model="productInventory.recent_sales" :disabled="true" :key="'recent_sales_' + productInventory.recent_sales" />
						<label>P.O. On Order</label>
						<number-input v-model="productInventory.on_order_po" :disabled="true" :key="'on_order_po_' + productInventory.on_order_po" />
					</div>
					<div data-v-step="7">
						<label>Reorder Point</label>
						<number-input :decimals="0" v-model="productInventory.reorder_point" :disabled="!productDetail.product_id" :key="'reorder_point' + productInventory.reorder_point" />
						<label>Restock Quantity</label>
						<number-input :decimals="0" v-model="productInventory.order_quantity" :disabled="!productDetail.product_id" :key="'order_quantity_' + productInventory.order_quantity" />
					</div>

				</div>
				<div class="sub-section no-border four-columns align-items-start">
					<div>
						<label>Current Cost</label>
						<number-input v-model="productInventory.cost" :disabled="true" :key="'current_cost_' + productInventory.cost" />
						<label-required label="Received Cost" :condition="productInventory.received_cost" />
						<input v-model="productInventory.received_cost" data-v-step="8" type="number" step="0.01" :disabled="!productDetail.product_id" @blur="formatNumber('received_cost')">
						<div style="font-size: 0.8em; margin: 1.5em 0 0 0;">
							<div class="button action" @click="manageOverride()">Price Override</div>				
						</div>
					</div>
					<div>
						<label>MSRP</label>
						<number-input v-model="productInventory.msrp" :disabled="userCannotEdit || !productDetail.product_id" :key="'msrp_' + productInventory.msrp" />
						<div data-v-step="9" >
							<label-required label="Online Price" :condition="productInventory.web_price" />
							<input v-model="productInventory.web_price" data-v-step="8" type="number" step="0.01" :disabled="!productDetail.product_id" @blur="formatNumber('web_price')">
							<label-required label="POS Price" :condition="productInventory.price" />
							<input v-model="productInventory.price" data-v-step="8" type="number" step="0.01" :disabled="!productDetail.product_id" @blur="formatNumber('price')">
						</div>
					</div>
					<div>
						<label>MAP</label>
						<number-input v-model="productInventory.map" :disabled="userCannotEdit || !productDetail.product_id" :key="'map_' + productInventory.map" />
						<label>Web Profit %</label>
						<number-input :decimals="1" v-model="productInventory.web_profit" :disabled="!productDetail.product_id" :key="'web_profit' + productInventory.web_profit" />
						<label>POS Profit %</label>
						<number-input :decimals="1" v-model="productInventory.pos_profit" :disabled="!productDetail.product_id" :key="'pos_profit' + productInventory.pos_profit" />
					</div>
					<div data-v-step="10" >
						<label>Is this a used item?</label>
		                <div class="control-group">
		                    <label class="radio first">
		                        <input type="radio" v-model="productDetail.is_used" :disabled="!productDetail.product_id" value="1">
		                        <span :class="{ disabled: !productDetail.product_id }"><i class="fas fa-check-circle"></i>Yes</span>
		                    </label>
		                    <label class="radio last">
		                        <input type="radio" v-model="productDetail.is_used" :disabled="!productDetail.product_id" value="0">
		                        <span :class="{ disabled: !productDetail.product_id }"><i class="fas fa-check-circle"></i>No</span>
		                    </label>
		                </div>
						<label>Exclude from website?</label>
		                <div class="control-group">
		                    <label class="radio first">
		                        <input type="radio" v-model="productInventory.excluded" :disabled="!productDetail.product_id" value="1">
		                        <span :class="{ disabled: !productDetail.product_id }"><i class="fas fa-check-circle"></i>Yes</span>
		                    </label>
		                    <label class="radio last">
		                        <input type="radio" v-model="productInventory.excluded" :disabled="!productDetail.product_id" value="0">
		                        <span :class="{ disabled: !productDetail.product_id }"><i class="fas fa-check-circle"></i>No</span>
		                    </label>
		                </div>

						<label>Average your cost?</label>
		                <div class="control-group">
		                    <label class="radio first">
		                        <input type="radio" v-model="productInventory.cost_average" :disabled="!productDetail.product_id" value="1">
		                        <span :class="{ disabled: !productDetail.product_id }"><i class="fas fa-check-circle"></i>Yes</span>
		                    </label>
		                    <label class="radio last">
		                        <input type="radio" v-model="productInventory.cost_average" :disabled="!productDetail.product_id" value="0">
		                        <span :class="{ disabled: !productDetail.product_id }"><i class="fas fa-check-circle"></i>No</span>
		                    </label>
							<span class="pointer" style="margin: 0 0 0 0.5em;"><i class="fas fa-info-circle" @click="showCostAverageModal = true" /></span>
		                </div>

					</div>
				</div>
			</div>

			<div v-if="fflTransactionInfoRequired && productDetail.serializable"class="tab-content" ref="additional_transaction_info">
				<div class="tab-section-title">Additional Transaction Info</div>
				<div class="checkbox-group" style="margin: 1em 0;">
					<span :class="['pointer', 'far', !productLogBook.transaction_info_required ? 'fa-check-square' : 'fa-square']" style="font-size: 1.25em;" @click="productLogBook.transaction_info_required = !productLogBook.transaction_info_required"></span>
					<label>Check if additional transaction info is <b>NOT</b> required with this receipt.</label>
				</div>
				<div v-if="productLogBook.transaction_info_required" class="two-columns">
					<div>
						<label>Firearm Dealer Permit Number (if applicable)</label>
						<input type="text" v-model="productLogBook.state_permit_number">
					</div>
					<div>
						<label-required label="Employee Completing Transaction" :condition="productLogBook.employee_name"></label-required>
						<input type="text" v-model="productLogBook.employee_name">
					</div>
				</div>
			</div>

			<div data-v-step="12" class="tab-content" ref="serial_numbers">
				<div class="tab-section-title">Serial Numbers</div>
				<div v-if="productDetail.serializable" class="two-one-columns">
					<div>
						<div v-if="!enteringSeries">
							<div class="two-columns" style="align-items: start;">
								<div v-for="(serialNumber, index) in productSerialNumbers" style="border-top: 1px solid #ccc; margin: 0.5em 0 0 0; padding: 0.5em 0.5em 0 0.5em;">
									<label-required label="Serial Number" :condition="serialNumber.serial_number"></label-required>
									<input type="text" v-model="serialNumber.serial_number" @change="addSerialInput()" :ref="'product_serial_number_' + index">
									<div v-if="fflTransactionInfoRequired && productLogBook.transaction_info_required">
										<label-required label="Finish" :condition="serialNumber.finish" />
										<select v-model="serialNumber.finish" :disabled="productLogBook.not_required" @change="addSerialInput()">
											<option value="">Select...</option>
											<option value="black">Black</option>
											<option value="blue_steel">Blue Steel</option>
											<option value="nickel">Nickel</option>
											<option value="stainless_steel">Stainless Steel</option>
											<option value="two_toned">Two-Toned</option>
											<option value="cerakote">Cerakote</option>
											<option value="other">Other</option>
										</select>
										<div v-if="serialNumber.finish == 'two_toned'" class="two-columns">
											<div>
												<label-required label="Tone 1" :condition="serialNumber.finish_two_toned_1"></label-required>
												<input type="text" v-model="serialNumber.finish_two_toned_1">
											</div>
											<div>
												<label-required label="Tone 2" :condition="serialNumber.finish_two_toned_2"></label-required>
												<input type="text" v-model="serialNumber.finish_two_toned_2">
											</div>
										</div>
										<div v-if="serialNumber.finish == 'cerakote'">
											<label-required label="Color" :condition="serialNumber.finish_cerakote"></label-required>
											<input type="text" v-model="serialNumber.finish_cerakote">
										</div>
										<div v-if="serialNumber.finish == 'other'">
											<label-required label="Other Finish" :condition="serialNumber.finish_other"></label-required>
											<input type="text" v-model="serialNumber.finish_other">
										</div>
									</div>
								</div>
							</div>
							<div :class="['button', 'spaced', productSerialNumbers[0]['serial_number'] != '' ? 'action' : 'disabled' ]" @click="removeSerialInput()">-</div>
							<div :class="['button', 'spaced', productSerialNumbers[productSerialNumbers.length - 1]['serial_number'] != '' ? 'action' : 'disabled' ]" @click="addSerialInput()">+</div>
							<span v-if="!productLogBook.transaction_info_required && productSerialNumbers[0]['serial_number'] == ''" class="inline-link" @click="enteringSeries = true">Enter a series?</span>
						</div>
						<div v-else>
							<div style="font-weight: bold; margin: 0 0 0.5em 0;">Enter the first and last serial numbers in the series</div>
							<div class="two-columns">
								<label-required label="First in series" :condition="seriesStart" />
								<label-required label="Last in series" :condition="seriesEnd" />
								<input type="text" v-model="seriesStart">
								<input type="text" v-model="seriesEnd">
							</div>
							<div :class="['button', 'smaller', 'spaced', seriesStart && seriesEnd ? 'neutral' : 'disabled']" @click="validateSerialNumberSeries()">Validate Series</div>
							<span v-if="validSeriesMessage">{{ validSeriesMessage }}</span>
						</div>
					</div>
					<div style="padding: 0 0 0 1em; border-left: 1px solid #ccc;">
						<div style="font-weight: bold; margin: 0 0 0.5em 0;">On-hand Serial Numbers</div>
						<div class="two-columns">
							<label v-for="(serialNumber, index) in onhandSerialNumbers">{{ serialNumber.serial_number }}</label>
						</div>
					</div>
				</div>
				<div v-else>
					<div class="message" style="margin: 0 1em 0 0;">Serial numbers are not required for non-serializable items.</div>
					<div style="font-size: 0.8em; margin: 1.5em 0 0 0;">
						<div :class="['button', productDetail.product_id ? 'neutral' : 'disabled']" style="margin: 1em 0;" @click="forceEnableSerialNumbers()">Force add serial numbers</div>
					</div>
				</div>
			</div>

			<div data-v-step="13" class="tab-content" ref="log_book">
				<div class="tab-section-title">Log Book</div>
				<div v-if="productDetail.serializable" class="two-columns" style="align-items: start;">
					<select v-model="productLogBook.ffl_log_book_id" :disabled="productLogBook.not_required">
						<option value="">Log Book...</option>
						<option v-for="(logbook, index) in logBooks" :value="logbook.ffl_log_book_id">{{ logbook.ffl_log_book_code }} - {{ logbook.description }}</option>
					</select>
					<div style="padding: 0.5em 0 0 0;">
						<span :class="['pointer', 'far', productLogBook.not_required ? 'fa-check-square' : 'fa-square']" style="font-size: 1.25em;" @click="productLogBook.not_required = !productLogBook.not_required"></span>
						<label style="margin: 0 0 0 0.5em;">Check if log book is <b>NOT</b> required for this serialized item</label>
					</div>
					<div>
						<label-required label="Receipt Date" :condition="productLogBook.receipt_date" />
						<div>
							<date-input v-model="productLogBook.receipt_date" :disabled="productLogBook.not_required" />
						</div>
						<label-required label="Manufacturer" :condition="productLogBook.manufacturer" />
						<input type="text" v-model="productLogBook.manufacturer" :disabled="productLogBook.not_required">
						<label>Importer</label>
						<input type="text" v-model="productLogBook.importer" :disabled="productLogBook.not_required">
						<div v-if="fflNumberInfo.manufacturer_importer">
							<label>Country of Manufacture</label>
							<input type="text" v-model="productLogBook.country_of_manufacture" :disabled="productLogBook.not_required">
						</div>
						<label-required label="Model" :condition="productLogBook.model" />
						<input type="text" v-model="productLogBook.model" :disabled="productLogBook.not_required">
						<label-required label="Type" :condition="productLogBook.gun_type" />
						<select v-model="productLogBook.gun_type" :disabled="productLogBook.not_required">
							<option value="">Gun type...</option>
							<option v-for="gunType in gunTypes" :value="gunType">{{ gunType }}</option>
						</select>
						<label-required label="Caliber" :condition="productLogBook.caliber" />
						<input type="text" v-model="productLogBook.caliber" :disabled="productLogBook.not_required">
					</div>
					<div>
						<label-required label="Received From" :condition="productLogBook.originator_full_name" />
						<input type="text" v-model="productLogBook.originator_full_name" :disabled="productLogBook.not_required">
						<label>FFL / DL Number</label>
						<input type="text" v-model="productLogBook.originator_ffl_number" :disabled="productLogBook.not_required">
						<label-required label="Address" :condition="productLogBook.originator_address_1" />
						<input type="text" v-model="productLogBook.originator_address_1" :disabled="productLogBook.not_required">
						<label-required label="City" :condition="productLogBook.originator_city" />
						<input type="text" v-model="productLogBook.originator_city" :disabled="productLogBook.not_required">
						<div v-if="supplierDetail.country_code && supplierDetail.country_code != 'US'" class="two-columns">
							<label-required label="Postal Code" :condition="productLogBook.originator_zip_code" />
							<label>Country Code</label>
							<input type="text" v-model="productLogBook.originator_zip_code" :disabled="productLogBook.not_required">
							<input type="text" v-model="supplierDetail.country_code" :disabled="productLogBook.not_required" maxlength="3">
						</div>
						<div v-else class="two-columns">
							<label-required label="State" :condition="productLogBook.originator_state" :disabled="productLogBook.not_required" />
							<label-required label="Zip Code" :condition="productLogBook.originator_zip_code" />
							<state-select :selectedState="productLogBook.originator_state" :disabled="productLogBook.not_required" showProvinces="true" placeHolder="Select..." @updateSelected="updateSelectedState"></state-select>
							<input type="text" v-model="productLogBook.originator_zip_code" :disabled="productLogBook.not_required">
						</div>
					</div>
				</div>
				<div v-else>
					<div class="message">Log book is not required for non-serializable items.</div>
				</div>
			</div>

			<div data-v-step="14" :class="['button', canSave() ? 'action' : 'disabled' ]" @click="receiveItem()">{{ receiveButtonLabel }}</div>

		</div>

		<div class="receive-inventory-progress">
			<div data-v-step="15" class="receive-inventory-progress-content">
				<div class="tab-section-title">This Receipt</div>
				<div v-if="supplierDetail.receipt_date" class="receipt-info">
					<div class="two-columns" style="align-items: start;">
						<div>
							<label>Date Received</label>
							<input type="date" v-model="supplierDetail.receipt_date" style="width: 8em;" />
							<div v-if="inventory_receipt_id != 'new'" :class="['button', saving ? 'disabled' : 'neutral', 'inline', 'spaced']" @click="saveReceiptDate()">Change</div>
						</div>
						<div v-if="supplierDetail.order_number">
							<label v-if="supplierDetail.order_number">Order Number</label>
							<div>{{ supplierDetail.order_number }}</div>
						</div>
					</div>
				</div>
				<div v-if="supplierDetail.full_name" class="receipt-info">
					{{ supplierDetail.full_name || supplierDetail.company_name }}<br>
					{{ supplierDetail.address_1 }}<br>{{ supplierDetail.city }} {{ supplierDetail.state }} {{ supplierDetail.zip_code }}<br>
					<label v-if="supplierDetail.ffl_number">FFL</label> {{ supplierDetail.ffl_number }}
					<label v-if="supplierDetail.drivers_license_number">DL</label> {{ supplierDetail.drivers_license_number }}
					<div>
						<div v-if="supplierDetail.client_id == client_id" class="button neutral inline spaced" @click="doEditSupplier()">Edit</div>
						<div class="button neutral inline" @click="backToList('change')">Change</div>
					</div>
				</div>
				<h2 style="width: 90%;">Items Received</h2>
				<div v-for="(product, index) in products" class="receipt-info product-list">
					<div>
						<div class="product-list-title">{{ product.product_detail.description }}</div>
						<label class="fixed-width">UPC</label> {{ product.product_detail.upc }}<br>
						<label class="fixed-width">Qty</label> {{ product.product_inventory.received }}
						<i :class="['product-list-icon', 'fas', product.show_detail ? 'fa-eye-slash' : 'fa-eye']" @click="showDetail(product)" />
						<div :class="['product-list-detail', 'two-columns', product.show_detail ? '' : 'hidden' ]">
							<div>
								<label class="fixed-width">Qty</label> {{ product.product_inventory.received }}<br>
								<label class="fixed-width">Cost</label> {{ product.product_inventory.received_cost }}
							</div>
							<div>
								<label class="fixed-width">Online</label> {{ product.product_inventory.web_price }}<br>
								<label class="fixed-width">POS</label> {{ product.product_inventory.price }}
							</div>
						</div>
						<div v-if="product.show_detail && product.product_inventory.serial_numbers && product.product_inventory.serial_numbers.length > 0">
							<div class="product-list-section-head">Serial Numbers...</div>
							<div class="two-columns">
								<div v-for="(serialNumber, index) in product.product_inventory.serial_numbers">{{ serialNumber }}</div>
							</div>
						</div>
						<div v-if="product.show_detail && product.product_inventory.pending_orders && product.product_inventory.pending_orders.length > 0">
							<div class="product-list-section-head">Pending orders with this item...</div>
							<div v-for="(pendingOrder, index) in product.product_inventory.pending_orders">
								<label>Order No</label> {{ pendingOrder.order_number }}<br>
								<label>Order Date</label> {{ pendingOrder.order_date }}<br>
								<label>Customer</label> {{ pendingOrder.customer }}
							</div>
						</div>
					</div>
					<div>
						<img :src="product.product_detail.image_src">
					</div>
				</div>
				<div class="receipt-info">
					<div class="two-columns">
						<label>Total Quantity Received</label>
						<div class="right">{{ totalQuantity }}</div>
						<label>Total Received Cost</label>
						<div class="right">{{ $formatCurrency(totalCost.toFixed(2)) || '0.00' }}</div>
					</div>
				</div>
				<div data-v-step="16" class="receipt-info">
					<div :class="['button', 'spaced', products.length > 0 ? 'neutral' : 'disabled' ]" @click="printTags()">Print Tags</div>
					<div :class="['button', products.length > 0 && !printing ? 'neutral' : 'disabled' ]" @click="printReceipt()">Print Receipt</div>
					<div v-if="printing" class="message center"><i class="fa fa-spinner fa-spin" /> Generating receipt...</div>
				</div>
				<div v-if="orderItems.length > 0" class="order-items">
					<h2 style="width: 90%;">Other items in this order</h2>
					<div style="margin: 0 0 0.5em 0;"><b><i>Click an item to receive it...</i></b></div>
					<div v-for="(item, index) in orderItems" class="receipt-info product-list pointer" @click="getProductByProductId(item.product_id)">
						<div>
							<div class="product-list-title">{{ item.description }}</div>
							<label class="fixed-width">UPC</label> {{ item.upc }}
							<div class="two-columns">
								<div><label class="fixed-width">Qty</label> {{ item.quantity }}</div>
								<div><label class="fixed-width">Cost</label> {{ item.order_price }}</div>
							</div>
						</div>
						<div class="product-list-image-wrapper">
							<img :src="item.image_src">
						</div>
					</div>
				</div>
			</div>
		</div>

	</div>

    <message-modal v-if="message" :message="message" :loading="saving" :errorStatus="messageErrorStatus" @dismiss="message = ''" />

	<div class="modal" v-if="showCostAverageModal">
		<div class="inner">
			<h2>Cost Averaging</h2>
			<div class="content">
				<p>Cost averaging will calculate your new cost as the average of your previously recorded cost and this item's received cost.</p>
				<p>We'll take into account how many you still have on hand at the current cost, and how many you are receiving at this cost.</p>
 				<p>
					Want to use cost averaging every time you receive an item?
	                <div class="control-group">
	                    <label class="radio first">
	                        <input type="radio" v-model="productInventory.cost_average" value="1">
	                        <span><i class="fas fa-check-circle"></i>Yes</span>
	                    </label>
	                    <label class="radio last">
	                        <input type="radio" v-model="productInventory.cost_average" value="0">
	                        <span><i class="fas fa-check-circle"></i>No</span>
	                    </label>
	                </div>
				</p>
			</div>
			<div class="controls">
				<div class="button cancel spaced" @click="showCostAverageModal = false">Cancel</div>
				<div class="button action spaced" @click="saveCostAveragingDefault()">Save Cost Averaging</div>
			</div>
		</div>
	</div>

	<div v-if="(!duplicatesOK || duplicatesOK == 0) && confirmDuplicatesMessage" class="modal" >
		<div class="inner">
			<h2>Confirm Duplicates</h2>
			<div class="content">
				<p>{{ confirmDuplicatesMessage }}</p>
				<p>Click <b>Duplicates Allowed</b> to proceed with this receipt and add these duplicate serial numbers to your logbooks.</p>
				<p>Click <b>Cancel</b> to enter a different serial number.</p>
			</div>
			<div class="controls">
				<div class="button neutral spaced" @click="duplicatesOK = 1; setConfirmDuplicates()">Duplicates Allowed</div>
				<div class="button cancel spaced" @click="duplicatesOK = 0; setConfirmDuplicates()">Cancel</div>
			</div>
		</div>
	</div>

	<div class="modal" v-if="showConfirmSequenceModal">
		<div class="inner">
			<h2>Confirm Serial Number Series</h2>
			<div class="content">
				<p>You are about to add {{ serialNumberSeries.length }} serial numbers...</p>
				<div class="four-columns">
					<div v-for="(serialNumber, index) in serialNumberSeries">{{ serialNumber }}</div>
				</div>
			</div>
			<div class="controls">
				<div class="button cancel spaced" @click="clearSerialNumberSeries()">Cancel</div>
				<div class="button action spaced" @click="confirmSerialNumberSeries()">Confirm</div>
			</div>
		</div>
	</div>

	<div class="modal" v-if="showPrintTagsModal">
		<div class="inner" style="min-width: 75vw; max-height: 80vh;">
			<h2>Print Tags</h2>
			<div class="content" style="max-height: 60vh;">
				<p>Select a product in this receipt...</p>
				<select v-model="loadedProductIndex">
					<option v-for="(product, index) in products" :value="index">{{ product.product_detail.description }}</option>
				</select>
				<tag-print :productDetail="products[loadedProductIndex].product_detail" :serialNumbers="products[loadedProductIndex].product_inventory.serial_numbers" key="tag_print_" />
			</div>
			<div class="controls">
				<div class="button cancel" @click="showPrintTagsModal = false">Cancel</div>
			</div>
		</div>
	</div>

	<div class="modal large-modal" v-if="editSupplier">
		<div class="inner" style="min-width: 70vw; max-height: 80vh;">
			<h2>{{ supplierDetail.supplier_id ? 'Edit' : 'New' }} Supplier</h2>
			<div class="content" style="max-height: 60vh;">
				<div class="three-columns">
					<div>
						<label-required label="Supplier Type" :condition="supplierDetail.supplier_type_id" />
						<select v-model="supplierDetail.supplier_type_id">
							<option value=''>Select...</option>
							<option v-for="(supplierType, index) in supplier_types" :value="supplierType.supplier_type_id">{{ supplierType.description }}</option>
						</select>
					</div>
				</div>
				<contact-detail-form :clientId="this.client_id" :contact="supplierDetail" :hideControls="true" @update="updateSupplierDetail" :key="'new_supplier_' + supplierDetail.supplier_id" />
			</div>
			<div class="controls">
				<div class="button spaced cancel" @click="cancelEditSupplier()">Cancel</div>
				<div :class="['button', 'spaced', canSaveSupplier ? 'action' : 'disabled']" @click="saveSupplier()">Save Supplier</div>
				<div v-if="modalMessage" class="message">{{ modalMessage }}</div>
			</div>
		</div>
	</div>

	<div class="modal" v-if="receivedProductDetail">
		<div class="inner">
			<h2>{{ receivedProductDetail.product_detail.description }}</h2>
			<div class="content">
				<div class="two-one-columns" style="align-items: start;">
					<div style="display: grid; grid-template-columns: 5em 1fr; line-height: 1.5em;">
						<label>UPC</label>
						<div>{{ receivedProductDetail.product_detail.upc }}</div>
						<label>Mfg</label>
						<div>{{ receivedProductDetail.product_detail.manufacturer }}</div>
						<label>SKU</label>
						<div>{{ receivedProductDetail.product_detail.sku }}</div>
						<label>Model</label>
						<div>{{ receivedProductDetail.product_detail.model }}</div>
						<label>Caliber</label>
						<div>{{ receivedProductDetail.product_detail.caliber }}</div>
						<label>MSRP</label>
						<div>{{ receivedProductDetail.product_detail.msrp }}</div>
						<label>MAP</label>
						<div>{{ receivedProductDetail.product_detail.map }}</div>
					</div>
					<div style="display: grid; grid-template-columns: 5em 1fr; line-height: 1.5em;">
						<label>Quantity</label>
						<div>{{ receivedProductDetail.product_inventory.received }}</div>
						<label>Rcvd Cost</label>
						<div>{{ receivedProductDetail.product_inventory.received_cost }}</div>
						<label>Curr Cost</label>
						<div>{{ receivedProductDetail.product_inventory.cost }}</div>
						<label>Web Price</label>
						<div>{{ receivedProductDetail.product_inventory.web_price }}</div>
						<label>POS Price</label>
						<div>{{ receivedProductDetail.product_inventory.price }}</div>
					</div>
				</div>

				<div v-if="receivedProductDetail.product_inventory.serial_sequence_numbers && receivedProductDetail.product_inventory.serial_sequence_numbers.length > 0" style="margin: 1em 0 0 0;">
					<label>Serial Numbers...</label>
					<div>
						<span v-for="(sequenceNumber, index) in receivedProductDetail.product_inventory.serial_sequence_numbers" style="padding: 0 1em 0 0;">{{ sequenceNumber.serial_number }} ({{ sequenceNumber.sequence_number }})</span>
					</div>
				</div>
				<div v-else-if="receivedProductDetail.product_inventory.serial_numbers && receivedProductDetail.product_inventory.serial_numbers.length > 0" style="margin: 1em 0 0 0;">
					<label>Serial Numbers...</label>
					<div>{{ receivedProductDetail.product_inventory.serial_numbers.join(', ') }}</div>
				</div>
				<div v-if="receivedProductDetail.product_inventory.pending_orders && receivedProductDetail.product_inventory.pending_orders.length > 0" style="margin: 1em 0 0 0;">
					<label>Pending orders with this item...</label>
					<div v-for="(pendingOrder, index) in receivedProductDetail.product_inventory.pending_orders">
						<label>Order No</label> {{ pendingOrder.order_number }}<br>
						<label>Order Date</label> {{ pendingOrder.order_date }}<br>
						<label>Customer</label> {{ pendingOrder.customer }}
					</div>
				</div>
			</div>
			<div class="controls">
				<div v-if="!receivedProductDetail.client_id" class="button spaced cancel" @click="requestProductEdit()">Request Product Edit</div>
				<div class="button spaced cancel" @click="receivedProductDetail = false">Done</div>
			</div>
		</div>
	</div>

	<div class="modal" v-if="showFatFingerModal">
		<div class="inner">
			<h2>Confirm High Quantity</h2>
			<div class="content">
				<p>You have entered a Received Quantity of {{ productInventory.received }} and a Received Cost of ${{ this.productInventory.received_cost }}.</p>
				<p>This will increase your inventory on hand cost by {{ $formatCurrency(productInventory.received * this.productInventory.received_cost) }}.</p>
				<p>Are you sure your Received Quantity and Received Cost are correct?</p>
			</div>
			<div class="controls">
				<div class="button cancel spaced" @click="showFatFingerModal = false">Cancel</div>
				<div class="button action spaced" @click="showFatFingerModal = false; fatFingerOK = true; receiveItem()">Yes, Receive</div>
			</div>
		</div>
	</div>

	<price-override-detail v-if="showPriceOverride" :listDetail="priceOverride" @backToList="finishedPriceOverride" />

	<help-popup :helpLink="{343:'Receive Inventory', 344:'Cost Averaging', 345:'Receive Serialized Non-Firearms Products', 346:'Receive Firearms', 347:'Printing Shelf and Box Labels'}" :tours="false"></help-popup>

</div>
</template>

<script>
import Loading from '@/components/Loading.vue'
import LabelRequired from '@/components/LabelRequired.vue'
import Checkbox from '@/components/Checkbox.vue'
import DateInput from '@/components/DateInput'
import StateSelect from '@/components/StateSelect.vue'
import ContactDetailForm from '@/components/ContactDetailForm'
import ToolTip from '@/components/ToolTip.vue'
import NumberInput from '@/components/NumberInput.vue'
import ProductDetailMinimum from '@/components/ProductDetailMinimum.vue'
import TagPrint from '@/components/TagPrint.vue'
import PriceOverrideDetail from '@/components/PriceOverrideDetail.vue'
import HelpPopup from '@/components/HelpPopup.vue'

export default {
	name: 'receive-inventory',
    props: ['inventory_receipt_id'],
    components: {
        'loading': Loading,
		'label-required': LabelRequired,
		'checkbox': Checkbox,
		'date-input': DateInput,
		'state-select': StateSelect,
        'contact-detail-form': ContactDetailForm,
		'tool-tip': ToolTip,
		'number-input': NumberInput,
        'product-detail-form': ProductDetailMinimum,
        'tag-print': TagPrint,
		'price-override-detail': PriceOverrideDetail,
		'help-popup': HelpPopup
    },
	data() {
		return {
			client_id: '',
            loading: false,
			message: '',
			messageErrorStatus: '',
			showSupplierList: false,
			suppliers: [],
			suppliersFromSearch: false,
			supplierDetail: {},
			supplier_types: [],
			products: [],
			loadedProductIndex: 0,
			totalQuantity: 0,
			totalCost: 0,
			productDetail: {
				new_product: false,
				new_image: false,
				serializable: false,
				is_firearm: false
			},

			receivedProductDetail: false,
			saveProductMessage: '',
			productInventory: {
                received: 0,
                received_cost: 0,
                cost_average: '0'
            },
			productSerialNumbers: [{ serial_number: '', finish: '', finish_two_toned_1: '', finish_two_toned_2: '', finish_cerakote: '', finish_other: '' }],
			enteringSeries: false,
			seriesStart: '',
			seriesEnd: '',
			seriesIsValid: false,
			serialNumberSeries: [],
			showConfirmSequenceModal: false,
			validSeriesMessage: '',
			onhandSerialNumbers: [],
			productLogBook: {
				not_required: false,
				ffl_log_book_id: '',
				transaction_info_required: false,
				finish: '',
				employee_name: '',
				state_permit_number: ''
			},
			employeeName: '',
			employeeDealerNumber: '',
			lastLogBookData: {},
			confirmDuplicatesMessage: '',
			duplicatesOK: '',
			logBooks: [],
			gunTypes: [],
			fflNumberInfo: {},
			fflTransactionInfoRequired: false,
			saving: false,
			saveMessage: '',
			printing: false,
			printMessage: '',
			showModal: false,
			modalForList: '',
			modalList: [],
			modalMessage: '',
			editSupplier: false,
			orderDetail: {},
			orderItems: [],
			orderItemSearchTerm: '',
			orderSearchMessage: '',
			showCostAverageModal: false,
			showFatFingerModal: false,
			fatFingerOK: false,
			showPrintTagsModal: false,
			setInventoryProfitTrigger: false,
			priceOverride: {},
			showPriceOverride: false,
			myOptions: {
				labels: {
					buttonSkip: 'End',
					buttonPrevious: 'Previous',
					buttonNext: 'Next',
					buttonStop: 'Finish'
				}
			},
			steps: [
				{
				target: '[data-v-step="0"]',
				content: `To start a receipt, first you will add the supplier. If you use this search bar, a list of any suppliers that match will come up, and you can select the one you want.`,
							params: {
					highlight: true,
								placement: 'top'
				}
				},
				{
          target: '[data-v-step="1"]',
          content: `If you have recently received from this supplier before, you can click the <i class="fas fa-search"></i> search icon instead of using the search bar. Your most recently receved-from suppliers will show and you can click the one you want.`,
					offset: 200,
					params: {
            highlight: true,
						placement: 'bottom',
          }
        },
				{
          target: '[data-v-step="2"]',
          content: `If the supplier you want is just not in the system, you can always add them as a new supplier.`,
					offset: 200,
					params: {
            highlight: true,
						placement: 'bottom',
          }
        },
				{
          target: '[data-v-step="3"]',
          content: `If you would like to receive straight from a Purchase Order or a Distributor Order that you have already created, you can search for the Order Number. A list of items from that order will appear over on the far right. You can click on any items from the PO to add to the receipt.`,
					offset: 200,
					params: {
            highlight: true,
						placement: 'bottom',
          }
        },
				{
          target: '[data-v-step="4"]',
          content: `You can choose to enter a Supplier Invoice Number and Freight if you want.`,
					offset: 200,
					params: {
            highlight: true,
						placement: 'bottom',
          }
        },
				{
          target: '[data-v-step="5"]',
          content: `If you aren't receiving from a PO or Distributor Order, scan or enter the UPC for the item you are receiving. The rest of the item information should fill out automatically based on the Distributor data in our system.`,
					params: {
            highlight: true,
						placement: 'top-start',
          }
        },
				{
					target: '[data-v-step="6"]',
					content: `If you are receiving a non-serialized item, enter the quantity you are receiving. If your item IS serializable, this number will automatically go up as you add serial numbers later.`,
					params: {
						highlight: true,
						placement: 'bottom'
					}
				},
				{
					target: '[data-v-step="7"]',
					content: `If you want to set up or change the reorder points for this item you can right now. The Reorder Point is the amount an on-hand item has to get down to before it triggers the reorder. The Restock Quantity is how much you want to order when the trigger happens.`,
					params: {
						highlight: true,
						placement: 'bottom'
					}
				},
				{
					target: '[data-v-step="8"]',
					content: `Enter the cost you are currently receiving this item at.`,
					params: {
						highlight: true,
						placement: 'bottom'
					}
				},
				{
					target: '[data-v-step="9"]',
					content: `If you haven't received this item before, you will need to enter your Online and POS price. These can be the same as each other, or different.`,
					params: {
						highlight: true,
						placement: 'bottom'
					}
				},
				{
					target: '[data-v-step="10"]',
					content: `You can select if an item is Used, if you want to Exclude it from your Website, and if you would like to Cost Average this item.`,
					params: {
						highlight: true,
						placement: 'bottom'
					}
				},
				{
					target: '[data-v-step="11"]',
					content: `If you have received this item before, the rest of these fields will be filled out for you automatically.`,
					params: {
						highlight: true,
						placement: 'bottom'
					}
				},
				{
					target: '[data-v-step="12"]',
					content: `If the item you are receiving is serializable, scan or enter each serial number into a field. The Quantity Received number will go up by 1 for each serial number you add.`,
					params: {
						highlight: true,
						placement: 'bottom'
					}
				},
				{
					target: '[data-v-step="13"]',
					content: `For items that you need to receive into your Logbooks, you can fill out all Logbook related fields as well and the serial numbers will be received into your logbooks.`,
					params: {
						highlight: true,
						placement: 'bottom'
					}
				},
				{
					target: '[data-v-step="14"]',
					content: `When you have filled out all the necessary fields, you can click the Receive Item button.`,
					params: {
						highlight: true,
						placement: 'bottom'
					}
				},
				{
					target: '[data-v-step="15"]',
					content: `Each item you receive will show up in the column on the right. You can continue to receive more items from the same supplier, and they will all be listed in this column.`,
					params: {
						highlight: true,
						placement: 'left'
					}
				},
				{
					target: '[data-v-step="16"]',
					content: `At any point after you start receiving items, you can print tags or a full page receipt.`,
					params: {
						highlight: true,
						placement: 'left'
					}
				}

      ]
		}
	},
	created() {
		this.getSupplierTypes()
		if (this.inventory_receipt_id) {
			if (this.inventory_receipt_id == 'new') {
				this.supplierDetail = JSON.parse(sessionStorage.getItem('supplier_detail'))
				let today = new Date()
				this.supplierDetail.receipt_date = today.toISOString().split('T')[0]
				if (this.supplierDetail.supplier_id == 'new') {
					this.createNew('supplier')
				} else {
					if (this.supplierDetail.order_number) {
						this.getOrder()
					}
				}
			} else {
				this.getCompleteDetail()
			}
		}
		if (this.$route.query.upc) {
			this.productDetail.upc = this.$route.query.upc
		}
	},
    watch: {
		'inventory_receipt_id'(newVal, oldVal) {
			if (newVal != 'new') {
				this.getCompleteDetail()
			}
		},
		'productInventory.received_cost'(newVal, oldVal) {
			if (!this.setInventoryProfitTrigger) {
				this.setInventoryProfitTrigger = 'received_cost'
				this.setInventoryProfit('received_cost')
			}
		},
		'productInventory.web_price'(newVal, oldVal) {
			if (!this.setInventoryProfitTrigger) {
				this.setInventoryProfitTrigger = 'web_price'
				this.setInventoryProfit('web_price')
			}
		},
		'productInventory.price'(newVal, oldVal) {
			if (!this.setInventoryProfitTrigger) {
				this.setInventoryProfitTrigger = 'price'
				this.setInventoryProfit('price')
			}
		},
		'productInventory.web_profit'(newVal, oldVal) {
			if (!this.setInventoryProfitTrigger) {
				this.setInventoryProfitTrigger = 'web_profit'
				this.setInventoryProfit('web_profit')
			}
		},
		'productInventory.pos_profit'(newVal, oldVal) {
			if (!this.setInventoryProfitTrigger) {
				this.setInventoryProfitTrigger = 'pos_profit'
				this.setInventoryProfit('pos_profit')
			}
		},
	},
	computed: {
		serialNumberCount() {
			return this.productSerialNumbers.filter(item => item.serial_number).length
		},
		canSaveSupplier() {
			return (this.supplierDetail.company_name || this.supplierDetail.last_name) && this.supplierDetail.address_1 && this.supplierDetail.city && (this.supplierDetail.state || this.supplierDetail.country_code) && this.supplierDetail.zip_code
		},
		userCannotEdit() {
			// based on product client_id
			return this.productDetail.client_id != this.client_id
		},
		filteredOrderItems() {
			return this.orderItems.filter(item => item.description.toLowerCase().indexOf(this.orderItemSearchTerm.toLowerCase()) > -1 || item.upc.toLowerCase().indexOf(this.orderItemSearchTerm.toLowerCase()) > -1);
		},
		validateNewProduct() {
			return this.productDetail.upc && this.productDetail.description && this.productDetail.category_id && this.productDetail.product_type_id
		},
		receivedCost: {
			get() {
				return this.productInventory.received_cost
			},
			set(value) {
				this.productInventory.received_cost = value
			}
		},
        receiveButtonLabel() {
            let label = 'Receive '
            if (this.enteringSeries) {
                label += this.serialNumberSeries.length + ' Serial Number'
                label += this.serialNumberSeries.length != 1 ? 's' : ''
                label += ' in Series'
            } else if (this.productDetail.serializable) {
                label += this.serialNumberCount + ' Serial Number'
                label += this.serialNumberCount != 1 ? 's' : ''
            } else {
                label += (this.productInventory.received || '0') + ' Item'
                label += (this.productInventory.received || '0') != 1 ? 's' : ''
            }
            return label
        }
	},
	methods: {
		formatNumber(number) {
            if (!this.productInventory[number]) {
                return false
            }
			let numberParts = this.productInventory[number].split('.')
			if (numberParts[1] && numberParts[0].length == 0) {
				this.productInventory[number] = '0.' + numberParts[1]
			}
			if (!numberParts[1] && numberParts[0].length > 0) {
				this.productInventory[number] += '.'
				this.productInventory[number] = this.productInventory[number].padEnd(this.productInventory[number].length + 2, '0')
			} else if (numberParts[1].length < 2 && numberParts[0].length > 0) {
				this.productInventory[number] = this.productInventory[number].padEnd(this.productInventory[number].length + (2 - numberParts[1].length) , '0')
			}
        },
		canSave() {
			if (this.saving) { return false }
            if (this.enteringSeries && this.serialNumberSeries.length == 0) {
                return false
            } else if (!this.enteringSeries && this.productDetail.serializable && this.serialNumberCount == 0) {
                return false
            } else if (!this.enteringSeries && !this.productDetail.serializable && (!this.productInventory.received || !this.productInventory.received_cost)) {
                return false
            }
			return true
		},
        sectionComplete(which) {
            let isComplete = false
			switch (which) {
				case 'supplier':
					isComplete = this.supplierDetail.contact_id
					break;
				case 'product':
					isComplete = this.productDetail.product_id
					break;
				case 'pricing':
					isComplete = (this.productDetail.serializable || this.productInventory.received) && this.productInventory.received_cost
					break;
				case 'serialnumbers':
					isComplete = this.productDetail.product_id && this.productDetail.serializable && (this.productSerialNumbers[0]['serial_number'] != '' || (this.serialNumberSeries.length > 0 && this.seriesIsValid))
					break;
				case 'logbook':
					isComplete = this.productDetail.product_id && this.productDetail.serializable && this.productSerialNumbers[0]['serial_number'] != '' && (this.productLogBook.ffl_log_book_id || this.productLogBook.not_required)
					break;
				case 'print':
					isComplete = this.productDetail.product_id
					break;
			}
			return isComplete
		},
		getSupplierTypes() {
			this.apiCall({ destination: 'get_list_inventory_supplier_types', data: { source: 'INVENTORY' } }).then(obj => {
				if (obj.status == 'success') {
					this.supplier_types = obj.supplier_types
					this.client_id = obj.client_id
					this.fflTransactionInfoRequired = obj.firearms_transaction_info_required
					this.employeeName = this.$fullName(obj.user_contact)
					this.employeeDealerNumber = obj.state_permit_number
				}
			}).catch(err => {
				console.log(err)
			})
		},
		getRecentSuppliers() {
			if (this.loading) { return }
			this.loading = true
			this.suppliersFromSearch = false
			this.suppliers = []
			this.apiCall({ destination: 'get_list_inventory_suppliers', data: { recent: true, context: 'supplier', source: 'INVENTORY' } }).then(obj => {
				this.suppliers = obj.suppliers
				this.loading = false
			}).catch(err => {
				console.log(err)
			})
		},
		getCompleteDetail() {
			this.productDetail = {}
			this.productInventory = {}
			this.productSerialNumbers = [{ serial_number: '', finish: '', finish_two_toned_1: '', finish_two_toned_2: '', finish_cerakote: '', finish_other: '' }]
			this.clearProductLogBook()
			this.apiCall({ destination: 'get_item_receive_inventory', data: { inventory_receipt_id: this.inventory_receipt_id, source: 'INVENTORY' } }).then(obj => {
				if (obj.status == 'success') {
					this.client_id = obj.client_id
					this.supplierDetail = obj.supplier_detail
					if (this.supplierDetail.order_number) {
						this.getOrder()
					}
					this.products = obj.products
					this.totalQuantity = 0
					this.totalCost = 0
					this.products.forEach((product, index) => {
						this.totalQuantity += parseInt(product.product_inventory.received)
						this.totalCost += parseInt(product.product_inventory.received) * parseFloat(product.product_inventory.received_cost)
					})
				}
			}).catch(err => {
				console.log(err)
			})
		},
		manageOverride() {
			// spread operator ... iterates objects 
			this.priceOverride = {
				...this.productDetail,
				...this.productInventory
			}
			console.log(this.priceOverride)
			this.showPriceOverride = true
		},
		finishedPriceOverride(updateRequired) {
			this.showPriceOverride = false
		},
		getOrder() {
			if (!this.supplierDetail.order_number) { return }
			let searchTerm = this.supplierDetail.order_number
			this.apiCall({ destination: 'get_item_receive_order', data: { search_term: searchTerm, source: 'INVENTORY' } }).then(obj => {
				if (obj.status == 'success') {
					this.orderDetail = obj.order_detail
					this.orderItems = obj.order_items
					this.supplierDetail = { notes: obj.order_detail.notes, ...this.supplierDetail }
					// any items in this order already received?
					if (this.products.length > 0) {
						this.products.forEach((product, index) => {
							this.orderItems.forEach((orderProduct, orderIndex) => {
								if (orderProduct.product_id == product.product_inventory.product_id && orderProduct.quantity <= product.product_inventory.received) {
									this.orderItems.splice(orderIndex, 1)
									return
								}
							})
						})
					}
				} else {
					this.orderSearchMessage = obj.message
                    setTimeout(() => {
                        this.orderSearchMessage = ''
						this.supplierDetail.order_number = ''
                    }, 2000)
				}
			}).catch(err => {
				console.log(err)
			})
		},
		saveReceiptDate() {
			if (this.saving) { return }
			this.saving = true
			this.apiCall({ destination: 'save_item_receipt_date', data: { inventory_receipt_id: this.inventory_receipt_id, receipt_date: this.supplierDetail.receipt_date, source: 'INVENTORY' } }).then(obj => {
				this.saving = false
			}).catch(err => {
				console.log(err)
			})
		},
		saveInvoiceFreight() {
			if (this.saving) { return }
			this.saving = true
			this.message = 'Saving invoice / freight / notes...'
			this.apiCall({ destination: 'save_item_invoice_freight', data: { inventory_receipt_id: this.inventory_receipt_id, supplier_invoice: this.supplierDetail.supplier_invoice, freight: this.supplierDetail.freight, notes: this.supplierDetail.notes, source: 'INVENTORY' } }).then(obj => {
				this.saving = false
				this.message = 'Saved!'
				setTimeout(() => {
					this.message = ''
				}, 1000)
			}).catch(err => {
				console.log(err)
			})
		},
		updateSupplierDetail(supplierDetail) {
			for (const [key, value] of Object.entries(supplierDetail)) {
				if (key != 'supplier_type_id' && key != 'client_id') {
					this.supplierDetail[key] = value
				}
			}
		},
		saveSupplier() {
			if (!this.canSaveSupplier) { return }
			if (this.saving) { return }
			this.saving = true
			this.supplierDetail.source = 'INVENTORY'
			this.apiCall({ destination: 'save_item_supplier', data: this.supplierDetail }).then(obj => {
				this.saving = false
				if (obj.status == 'success') {
					this.supplierDetail.full_name = obj.full_name
					this.supplierDetail.search_term = this.supplierDetail.full_name
					this.supplierDetail.contact_id = obj.contact_id
					this.supplierDetail.supplier_id = obj.supplier_id
					this.editSupplier = false
				} else {
					this.modalMessage = obj.message
				}
			}).catch(err => {
				console.log(err)
			})
		},
		cancelEditSupplier() {
			this.editSupplier = false
			if (this.supplierDetail.supplier_id == 'new') {
				this.backToList()
			}
		},
		forceEnableSerialNumbers() {
			if (this.productDetail.product_id) {
				this.productDetail.serializable = !this.productDetail.serializable
			}
		},
		setConfirmDuplicates() {
			if (!this.duplicatesOK || this.duplicatesOK == 0) {
				this.productSerialNumbers[this.productSerialNumbers.length - 1]['serial_number'] = ''
				this.confirmDuplicatesMessage = ''
				this.duplicatesOK = ''
			}
		},
		addSerialInput() {
			if (this.productSerialNumbers[this.productSerialNumbers.length - 1]['serial_number'] == '') {
				return
			}
			if (this.fflTransactionInfoRequired && this.productLogBook.transaction_info_required && this.productSerialNumbers[this.productSerialNumbers.length - 1]['finish'] == '') {
				return
			}
			if (!this.duplicatesOK) {
				// any duplicate serial numbers in productSerialNumbers?
				let checkSerialNumbers = []
				this.productSerialNumbers.forEach(serialNumber => {
					if (!checkSerialNumbers.includes(serialNumber.serial_number) && serialNumber.serial_number != '') {
						checkSerialNumbers.push(serialNumber.serial_number)
					}
				})
				if (checkSerialNumbers.length != this.productSerialNumbers.length) {
					this.confirmDuplicatesMessage = 'Duplicate found in these new serial numbers.'
					return
				}
				// any new serial numbers already on hand?
				let duplicateFound = false
				this.onhandSerialNumbers.forEach(serialNumber => {
					if (checkSerialNumbers.indexOf(serialNumber.serial_number) !== -1) {
						duplicateFound = true
					}
				})
				if (duplicateFound) {
					this.confirmDuplicatesMessage = 'Duplicate found in on-hand serial numbers.'
					return
				}
			}
			if (this.productSerialNumbers[this.productSerialNumbers.length - 1]['serial_number'] != '') {
				this.productSerialNumbers.push({ serial_number: '', finish: '', finish_two_toned_1: '', finish_two_toned_2: '', finish_cerakote: '', finish_other: '' })
				this.$nextTick(() => {
					let inputRef = 'product_serial_number_' + (this.productSerialNumbers.length - 1)
					this.$refs[inputRef][0].focus()
				})
			}
		},
		removeSerialInput() {
			if (this.productSerialNumbers.length > 1) {
				this.productSerialNumbers.pop()
			} else {
				this.productSerialNumbers.splice(0, 1, { serial_number: '', finish: '', finish_two_toned_1: '', finish_two_toned_2: '', finish_cerakote: '', finish_other: '' })
			}
			this.$nextTick(() => {
				let inputRef = 'product_serial_number_' + (this.productSerialNumbers.length - 1)
				this.$refs[inputRef][0].focus()
			})
		},
		validateSerialNumberSeries() {
			if (!this.seriesStart && !this.seriesEnd) {
				this.validSeriesMessage = 'Start and end cannot be empty'
				return
			}
			this.seriesIsValid = false
			this.validSeriesMessage = ''

			// this is simpler, but fails if there is a number in the prefix!
			//let startNumber = this.seriesStart.replace(/[^0-9]/g,'')
			//let endNumber = this.seriesEnd.replace(/[^0-9]/g,'')
			let startNumber = ''
			for (let i = this.seriesStart.length - 1; i > 0; i --) {
				if (isNaN(this.seriesStart.charAt(i))) {
					break
				}
				startNumber += this.seriesStart.charAt(i)
			}
			// reverse the number
			startNumber = startNumber.split('').reverse().join('')
			let endNumber = ''
			for (let i = this.seriesEnd.length - 1; i > 0; i --) {
				if (isNaN(this.seriesEnd.charAt(i))) {
					break
				}
				endNumber += this.seriesEnd.charAt(i)
			}
			// reverse the number
			endNumber = endNumber.split('').reverse().join('')

			if (!startNumber || !endNumber) {
				this.validSeriesMessage = 'Series is not valid'
				return
			}
			if (startNumber > endNumber) {
				this.validSeriesMessage = 'Start must be greater than end'
				return
			}
			if (startNumber.length != endNumber.length) {
				this.validSeriesMessage = 'Start and end must have the same number of digits'
				return
			}

			let startPrefix = this.seriesStart.replace(startNumber, '')
			let endPrefix = this.seriesEnd.replace(endNumber, '')
			if (startPrefix != endPrefix) {
				this.validSeriesMessage = 'Start and end prefix must match'
				return
			}

			// generate the sequence array
			// account for leading and trailing zeroes!
			let padZeroLeft = startNumber.charAt(0) == '0'
			this.serialNumberSeries = []
			for (let i = parseInt(startNumber); i <= parseInt(endNumber); i++) {
				if (padZeroLeft) {
					this.serialNumberSeries.push(startPrefix + i.toString().padStart(startNumber.length, '0'))
				} else {
					this.serialNumberSeries.push(startPrefix + i)
				}
			}

			if (!this.duplicatesOK) {
				// any new serial numbers already on hand?
				let duplicateFound = false
				this.onhandSerialNumbers.forEach(serialNumber => {
					if (this.serialNumberSeries.indexOf(serialNumber.serial_number) !== -1) {
						duplicateFound = true
						return
					}
				})
				if (duplicateFound) {
					this.confirmDuplicatesMessage = 'Series would duplicate one or more on-hand serial numbers.'
					return
				}
			}

			this.validSeriesMessage = 'There are ' + this.serialNumberSeries.length + ' serial numbers in the series'
			this.showConfirmSequenceModal = true
		},
		clearSerialNumberSeries() {
			this.seriesIsValid = false
			this.showConfirmSequenceModal = false
			this.serialNumberSeries = []
			this.seriesStart = ''
			this.seriesEnd = ''
			this.validSeriesMessage = 'Serial number sequence canceled'
			this.productInventory.received = '';
		},
		confirmSerialNumberSeries() {
			this.productInventory.received = this.serialNumberSeries.length;
			this.seriesIsValid = true
			this.showConfirmSequenceModal = false
		},
		getProductByProductId(productId) {
			if (this.loading) { return }
			this.loading = true
			this.apiCall({ destination: 'get_item_product_by_id', data: { product_id: productId, source: 'INVENTORY' } }).then(obj => {
				this.loading = false
				if (obj.status == 'success') {
					this.updateProduct(obj.product_detail)
				}
			}).catch(err => {
				console.log(err)
			})
		},
		updateProduct(productDetail) {
			// emitted productDetail from ProductDetailMinimum component
			if (productDetail.new_product) {
				// emitted new product, just set productDetail and client_id so save buttons will display
				this.productDetail = productDetail
				this.productDetail.client_id = this.client_id
				this.clearProductLogBook()
				return
			}
			if (productDetail.product_id && (this.productDetail.product_id != productDetail.product_id || productDetail.force_update || productDetail.new_product)) {
				// scanned product is different from current product, so get inventory
				this.productDetail.force_update = false // reset flag if it was set in saveNewProduct
				this.getProductInventory(productDetail.product_id, productDetail.serializable)
				this.productDetail = productDetail
			} else if (!productDetail.upc) {
				// no upc, so clear detail and inventory to start again
				this.productInventory = {}
			} else if (productDetail.client_id == this.client_id) {
				// not a new product, not a different product id, and it's a client product, so update the productDetail from the component
				this.productDetail = productDetail
			}
			// if firearm or serializable, populate log book control lists
			if (this.productDetail.serializable && this.logBooks.length == 0) {
				this.apiCall({ destination: 'get_log_book_control_lists', data: { source: 'INVENTORY' } }).then(obj => {
					this.logBooks = obj.logbooks
					this.gunTypes = obj.gun_types
					this.fflNumberInfo = obj.ffl_number_info
				}).catch(err => {
					console.log(err)
				})
			}
			// if firearm or serializable, populate logbook object
			if (productDetail.is_firearm || productDetail.serializable) {
				if (!productDetail.last_logbook_data) {
					productDetail.last_logbook_data = {}
				}
				this.setLogBookData()
			}
		},
		cancelNewProduct() {
			this.productDetail = {}
			this.productInventory = {}
		},
		saveNewProduct() {
			if (this.saving) { return }
			if (!this.validateNewProduct) { return }
			this.saveProductMessage = 'Saving new product...'
			this.saving = true
			this.productDetail.source = 'INVENTORY'
			this.apiCall({ destination: 'save_item_product_info', data: this.productDetail }).then(obj => {
				this.saving = false
				this.saveProductMessage = obj.message
				if (obj.status == 'success') {
					this.productDetail.product_id = obj.product_id
					this.productDetail.new_product = false
					this.productDetail.force_update = true // will force updateProduct to acquire inventory and log book info
					this.productDetail.is_firearm = obj.is_firearm // will allow updateProduct to set log book info if firearm
					//console.log(this.productDetail)
					this.updateProduct(this.productDetail)
				}
			}).catch(err => {
				console.log(err)
			})
		},
		setLogBookData() {
			this.productLogBook.receipt_date = this.$today().clone().format('YYYY-MM-DD')
			this.productLogBook.ffl_log_book_id = this.lastLogBookData.ffl_log_book_id || this.productDetail.ffl_log_book_id || ''
			this.productLogBook.manufacturer = this.lastLogBookData.manufacturer || this.productDetail.last_logbook_data.manufacturer || this.productDetail.manufacturer
			this.productLogBook.importer = this.lastLogBookData.importer || this.productDetail.last_logbook_data.importer
			this.productLogBook.country_of_manufacture = this.lastLogBookData.country_of_manufacture || this.productDetail.last_logbook_data.country_of_manufacture
			this.productLogBook.model = this.lastLogBookData.model || this.productDetail.last_logbook_data.model || this.productDetail.model
			this.productLogBook.gun_type = this.lastLogBookData.gun_type || this.productDetail.last_logbook_data.gun_type || this.productDetail.gun_type
			this.productLogBook.caliber = this.lastLogBookData.caliber || this.productDetail.last_logbook_data.caliber || this.productDetail.caliber
			this.productLogBook.finish = this.lastLogBookData.finish || ''
			this.productLogBook.originator_full_name = this.supplierDetail.full_name || this.supplierDetail.company_name
			this.productLogBook.originator_ffl_number = this.supplierDetail.ffl_number || this.supplierDetail.drivers_license_number
			this.productLogBook.originator_address_1 = this.supplierDetail.address_1
			this.productLogBook.originator_city = this.supplierDetail.city
			this.productLogBook.originator_state = this.supplierDetail.state
			this.productLogBook.originator_zip_code = this.supplierDetail.zip_code
			this.productLogBook.transaction_info_required = false
			this.productLogBook.employee_name = this.employeeName
			this.productLogBook.state_permit_number = ''
            this.productLogBook.transaction_info_required = true // default to true, will be overridden if this isn't required for the product or if FFL doesn't require it
		},
		updateSelectedState(state) {
			this.productLogBook.originator_state = state
		},
		setProduct(productDetail) {
			this.productDetail = productDetail
			this.productInventory = productDetail.inventory
		},
		clearProduct() {
			this.productDetail = {
				serializable: false
			}
		},
		setInventoryProfit(trigger) {
			let useCost = this.productInventory.received_cost || this.productInventory.cost
			switch (trigger) {
				case 'received_cost':
					if (useCost && this.productInventory.web_price) {
						let webProfit = (100 * (1 - (useCost / this.productInventory.web_price))).toFixed(1);
						this.productInventory.web_profit = webProfit
					} else {
						this.productInventory.web_profit = ''
					}
					if (useCost && this.productInventory.price) {
						let posProfit = (100 * (1 - (useCost / this.productInventory.price))).toFixed(1);
						this.productInventory.pos_profit = posProfit
					} else {
						this.productInventory.pos_profit = ''
					}
					break;
				case 'web_price':
					if (useCost && this.productInventory.web_price) {
						let webProfit = (100 * (1 - (useCost / this.productInventory.web_price))).toFixed(1);
						this.productInventory.web_profit = webProfit
					} else {
						this.productInventory.web_profit = ''
					}
					break;
				case 'price':
					if (useCost && this.productInventory.price) {
						let posProfit = (100 * (1 - (useCost / this.productInventory.price))).toFixed(1);
						this.productInventory.pos_profit = posProfit
					} else {
						this.productInventory.pos_profit = ''
					}
					break;
				case 'web_profit':
					if (useCost && this.productInventory.web_profit) {
						let webPrice = (useCost / (1 - this.productInventory.web_profit / 100)).toFixed(2);
						this.productInventory.web_price = webPrice
					} else {
						this.productInventory.web_price = ''
					}
					break;
				case 'pos_profit':
					if (useCost && this.productInventory.pos_profit) {
						let posPrice = (useCost / (1 - this.productInventory.pos_profit / 100)).toFixed(2);
						this.productInventory.price = posPrice
					} else {
						this.productInventory.price = ''
					}
					break;
			}
			// slight delay while DOM catches up prevents recalculation of prices when profit changes
            setTimeout(() => {
				this.setInventoryProfitTrigger = false
            }, 500)
		},
		clearProductLogBook() {
			this.productLogBook = {
				not_required: false,
				ffl_log_book_id: '',
				receipt_date: '',
				manufacturer: '',
				importer: '',
				country_of_manufacture: '',
				model: '',
				gun_type: '',
				caliber: '',
				finish: '',
				originator_full_name: '',
				originator_ffl_number: '',
				originator_address_1: '',
				originator_city: '',
				originator_state: '',
				originator_zip_code: '',
				transaction_info_required: false,
				employee_name: this.employeeName,
				state_permit_number: ''
			}
            this.enteringSeries = false
		},
		clearAll() {
			this.clearSupplier()
			this.clearProduct()
			this.productInventory = {}
			this.productSerialNumbers = [{ serial_number: '', finish: '', finish_two_toned_1: '', finish_two_toned_2: '', finish_cerakote: '', finish_other: '' }]
			this.products = []
			this.clearProductLogBook()
			this.totalQuantity = 0
			this.totalCost = 0
			this.clearSerialNumberSeries()
			document.getElementById('detail_receive_inventory').scrollTop = 0
			if (this.inventory_receipt_id != 'new') {
				this.$router.push('/inventory/receive-inventory/new')
			}
		},
		doEditSupplier() {
			this.editSupplier = true
		},
		getProductInventory(productId, serializable) {
			this.loading = true
			this.lastLogBookData = {}
			this.apiCall({ destination: 'get_item_product_inventory', data: { product_id: productId, include_serial_numbers: serializable, get_pending_orders: true, source: 'INVENTORY' } }).then(obj => {
				this.loading = false
				this.productInventory = obj.inventory
				if (this.productDetail.is_firearm) {
					this.productInventory.received = this.productSerialNumbers.length - 1
				}
				if (obj.serial_numbers) {
					this.onhandSerialNumbers = obj.serial_numbers
				}
				if (obj.pending_orders) {
					this.productInventory.pending_orders = obj.pending_orders
				}
				if (obj.last_logbook_data) {
					this.lastLogBookData = obj.last_logbook_data
					this.setLogBookData()
				}
			}).catch(err => {
				console.log(err)
			})
		},
		createNew(which) {
			let createNewFor = which || this.modalForList
			switch (createNewFor) {
				case 'supplier':
					this.editSupplier = true
					this.showSupplierList = false
					break;
			}
		},
		receiveItem() {
			if (!this.canSave) { return }
			// if (this.saving) { return }

			if ((this.seriesStart || this.seriesEnd) && !this.seriesIsValid) {
				this.validateSerialNumberSeries()
				return
			}

			if (!this.enteringSeries && this.productDetail.serializable) {
				// remove any elements with empty serial numbers
				this.productSerialNumbers = this.productSerialNumbers.filter(serialNumber => serialNumber.serial_number && serialNumber.serial_number != '')
				this.productInventory.received = this.productSerialNumbers.length
			}
			// catch fat-fingered quantity * cost?
			if (this.productInventory.received * this.productInventory.received_cost > 10000 && !this.fatFingerOK) {
				this.showFatFingerModal = true
				return
			}

			if (this.productDetail.serializable && (!this.productLogBook.receipt_date && !this.productLogBook.not_required)) {
				this.messageErrorStatus = 'invalid' 
				this.message = 'Enter receipt date'
				return
			}

			this.fatFingerOK = false
			this.saving = true
			this.message = "Checking info..."

			// do we have all required data?
			if (!this.supplierDetail.contact_id) {
				this.message = "Supplier must be selected"
				this.messageErrorStatus = 'invalid'
				this.saving = false
				return
			}
			if (!this.productDetail.product_id) {
				this.message = "Product must be selected"
				this.messageErrorStatus = 'invalid'
				this.saving = false
				return
			}
			if (!this.productInventory.received || this.productInventory.received <= 0) {
				if (this.productDetail.serializable && !this.productLogBook.not_required && this.productSerialNumbers[0]['serial_number'] == '' && this.serialNumberSeries.length == 0 && !this.seriesIsValid) {
					this.message = "Enter one or more serial numbers"
					this.messageErrorStatus = 'invalid'
					this.$refs['serial_numbers'].scrollIntoView({ behavior: 'smooth', block: 'start', inline: "nearest" })
					this.saving = false
					return
				} else {
					this.message = "Product received quantity is required"
					this.messageErrorStatus = 'invalid'
					this.$refs['inventory_pricing'].scrollIntoView({ behavior: 'smooth', block: 'start', inline: "nearest" })
					this.saving = false
					return
				}
			}
			if (!this.productInventory.received_cost || !this.productInventory.web_price || !this.productInventory.price) {
				this.message = "Recieved Cost, Online Price and POS Price are required"
				this.messageErrorStatus = 'invalid'
				this.$refs['inventory_pricing'].scrollIntoView({ behavior: 'smooth', block: 'start', inline: "nearest" })
				this.saving = false
				return
			}
			if (this.productDetail.is_firearm && !this.productLogBook.not_required && this.productDetail.serializable) {
				for (const [key, value] of Object.entries(this.productLogBook)) {
					if (['not_required', 'importer', 'country_of_manufacture', 'originator_ffl_number', 'transaction_info_required', 'finish', 'employee_name', 'state_permit_number'].includes(key)) { continue }
					if (key == 'originator_state' && this.supplierDetail.country_code && this.supplierDetail.country_code != 'US') { continue }
					if (value == '') {
						this.message = "Enter all required log book info (" + key + ")"
						this.messageErrorStatus = 'invalid'
						this.$refs['log_book'].scrollIntoView({ behavior: 'smooth', block: 'start', inline: "nearest" })
						this.saving = false
						return
					}
				}
			}
			if (this.fflTransactionInfoRequired && this.productLogBook.transaction_info_required && !this.productLogBook.not_required) {
				for (const [key, value] of Object.entries(this.productLogBook)) {
					if (['employee_name'].includes(key)) {
						if (value == '') {
							this.message = "Enter all required firearms transaction info"
							this.messageErrorStatus = 'invalid'
							this.$refs['log_book'].scrollIntoView({ behavior: 'smooth', block: 'start', inline: "nearest" })
							this.saving = false
							return
						}
					}
				}
			}

			let useInventoryReceiptId = this.inventory_receipt_id == 'new' ? '' : this.inventory_receipt_id
			let postObject = {
				source: 'INVENTORY',
				inventory_receipt_id: useInventoryReceiptId,
				product_supplier: this.supplierDetail,
				order_detail: this.orderDetail,
				product_detail: this.productDetail,
				product_inventory: this.productInventory,
				product_log_book: this.productLogBook,
				product_serial_numbers: []
			}

			// if series, set posted serial number array to the series
			if (this.serialNumberSeries.length > 0 && this.seriesIsValid) {
				postObject.product_serial_numbers = this.serialNumberSeries
			} else {
				// only post non-empty serial numbers
				this.productSerialNumbers.forEach(serialNumber => {
					if (serialNumber.serial_number && serialNumber.serial_number != '') {
						postObject.product_serial_numbers.push(serialNumber.serial_number)
					}
				})
			}
			if (postObject.product_serial_numbers.length > 0) {
				postObject.product_log_book.duplicates_ok = this.duplicatesOK
				this.message = "Recieving " + postObject.product_serial_numbers.length + " serial number" + (postObject.product_serial_numbers.length > 1 ? "s" : "") + "..."
			} else {
				this.message = "Recieving " + this.productInventory.received + " item" + (this.productInventory.received > 1 ? "s" : "") + "..."
			}

			this.apiCall({ destination: 'save_item_receive_inventory', data: postObject }).then(obj => {
				if (obj.status == 'success') {

					if (this.fflTransactionInfoRequired && this.productLogBook.transaction_info_required) {
						this.message = 'Saving additional transaction info...'
						let fflLogBookEntryIds = {}
						if ('ffl_log_book_entry_ids' in obj) {
							fflLogBookEntryIds = obj.ffl_log_book_entry_ids
						}
						// transaction records require additional information
						let postSerialNumbers = {}
						for (let i = 0; i < this.productSerialNumbers.length; i++) {
							postSerialNumbers[i] = {
								serial_number: this.productSerialNumbers[i].serial_number,
								caliber: this.productLogBook.caliber,
								gun_type: this.productLogBook.gun_type,
								manufacturer: this.productLogBook.manufacturer,
								model: this.productLogBook.model,
								finish: this.productSerialNumbers[i].finish,
								finish_two_toned_1: this.productSerialNumbers[i].finish_two_toned_1,
								finish_two_toned_2: this.productSerialNumbers[i].finish_two_toned_2,
								finish_cerakote: this.productSerialNumbers[i].finish_cerakote,
								finish_other: this.productSerialNumbers[i].finish_other,
								ffl_log_book_entry_id: fflLogBookEntryIds[this.productSerialNumbers[i].serial_number],
							}
						}
						this.apiCall({ destination: 'save_item_ffl_transaction_record', data: { is_receipt: true, entry: this.productLogBook, contact: this.supplierDetail, serial_numbers: postSerialNumbers } }).then(obj => {
							this.messageStatus = obj.status
							if (obj.status == 'success') {
								this.saving = false
								this.messageErrorStatus = ''
								this.message = ''
							} else {
								this.message = "Error: " + obj.message
								this.messageTimeout = 0
							}
						}).catch(err => {
							console.log(err)
						})

					} else {
						this.saving = false
						this.messageErrorStatus = ''
						this.message = ''
					}

					this.receivedProductDetail = postObject
					this.receivedProductDetail.product_detail.msrp = this.productInventory.msrp
					this.receivedProductDetail.product_detail.map = this.productInventory.map
					this.receivedProductDetail.product_inventory.cost = obj.cost
					this.receivedProductDetail.product_inventory.serial_sequence_numbers = obj.serial_sequence_numbers

					// is this product already in the list?
					let productInList = false
					this.products.forEach((product, index) => {
						if (product.product_detail.product_id == this.productDetail.product_id) {
							this.products[index].product_detail.msrp = this.productInventory.msrp
							this.products[index].product_detail.map = this.productInventory.map
							this.products[index].product_inventory.received = parseInt(this.products[index].product_inventory.received) + parseInt(this.productInventory.received)
							this.products[index].product_inventory.received_cost = this.productInventory.received_cost
							this.products[index].product_inventory.web_price = this.productInventory.web_price
							this.products[index].product_inventory.price = this.productInventory.price
							this.productSerialNumbers.forEach(serialNumber => {
								if (serialNumber.serial_number) {
									this.products[index].product_inventory.serial_numbers.push(serialNumber.serial_number)
								}
							})
							productInList = true
							return
						}
					})

					// add product object to receipt
					if (!productInList) {
						postObject.show_detail = false
						if (!postObject.product_inventory.serial_numbers) {
							postObject.product_inventory.serial_numbers = []
							this.productSerialNumbers.forEach(serialNumber => {
								if (serialNumber.serial_number) {
									postObject.product_inventory.serial_numbers.push(serialNumber.serial_number)
								}
							})
						}
						this.products.push(JSON.parse(JSON.stringify(postObject)))
						this.loadedProductIndex = this.products.length - 1
					}

					// is this product in the orderItems list?
					this.orderItems.forEach((product, index) => {
						if (product.product_id == this.productDetail.product_id) {
							this.orderItems.splice(index, 1)
							return
						}
					})

					document.getElementById('detail_receive_inventory').scroll({top:0,behavior:'smooth'});

					if (this.inventory_receipt_id != obj.inventory_receipt_id) {
						this.$router.push('/inventory/receive-inventory/' + obj.inventory_receipt_id)
					} else {
						// timeout allows smooth scroll to top before ProductDetailMinimum component sets focus on input
	                    setTimeout(() => {
							this.clearProduct()
							this.productInventory = {}
							this.productSerialNumbers = [{ serial_number: '', finish: '', finish_two_toned_1: '', finish_two_toned_2: '', finish_cerakote: '', finish_other: '' }]
							this.clearSerialNumberSeries()
							this.clearProductLogBook()
	                    }, 500)
						this.totalQuantity = 0
						this.totalCost = 0
						this.getCompleteDetail();
					}
				} else {
					this.message = obj.message
					this.messageErrorStatus = 'error'
				}
			}).catch(err => {
				console.log(err)
			})
		},
		saveCostAveragingDefault() {
			if (this.saving) { return }
			this.saving = true
			this.apiCall({ destination: 'save_item_preference', data: { preference_code: 'DEFAULT_COST_AVERAGING', value: this.productInventory.cost_average, source: 'INVENTORY' } }).then(obj => {
				this.saving = false
				this.showCostAverageModal = false
			}).catch(err => {
				console.log(err)
			})
		},
		printTags() {
			if (this.products.length > 0) {
				this.showPrintTagsModal = true
			}
		},
		printReceipt() {
			if (this.printing) { return }
			if (this.products.length == 0) { return }
			this.printing = true
			this.apiCall({ destination: 'get_item_receive_inventory', data: { inventory_receipt_id: this.inventory_receipt_id, do_print: true, source: 'INVENTORY' } }).then(obj => {
				this.printing = false
				if (obj.status == 'success') {
					window.open(obj.pdf_url)
				}
			}).catch(err => {
				console.log(err)
			})
		},
		showDetail(product) {
			this.receivedProductDetail = product
		},
		backToList(change) {
			sessionStorage.removeItem('supplier_detail')
			if (change) {
				sessionStorage.setItem('change_supplier', this.inventory_receipt_id)
			}
			this.$router.push('/inventory/receive-inventory')
		},
		requestProductEdit() {
			this.$router.push('/help-center/support-tickets-detail/new?topic=Please Edit ' + this.receivedProductDetail.product_detail.upc + '&priority=low&tag=product&content=Please edit the following info for UPC ' + this.receivedProductDetail.product_detail.upc + '...')
		}
	}
}
</script>

<style lang="scss" scoped>
@import "@/styles/_colors.scss";

.button {
  &.inline {
    padding: 0.25em 1em;

    &.update-notes {
      padding: 1em;
    }
  }
}

.filters {
	position: relative;
	.section-list {
		font-size: 1.25em;
		line-height: 2em;
        i {
            opacity: 0.6;
            color: #ccc;
        }
        i.section_complete {
            opacity: 1;
            color: #74ad4a;
        }
	}
}

.receive-inventory {
	display: grid;
	grid-template-columns: 1fr 20em;
	grid-column-gap: 2em;
	.main-receive-column { padding: 0 0 2em 0; }
	.receive-inventory-progress {
		border-left: 1px solid $borders;
		.receive-inventory-progress-content {
			position: fixed;
			height: calc(100vh - 9em);
			overflow-y: scroll;
			padding: 0 0 2em 1em;
			label { font-size: 0.75em; color: $dark-grey; }
			label.fixed-width {
				display: inline-block;
				width: 3em;
			}
			.receipt-info {
				border-bottom: 1px solid $borders;
				margin: 0 1em 1em 0;
				padding: 0 0 1em 0;
				line-height: 1.5em;
			}
			.product-list {
				display: grid;
				grid-template-columns: 1fr 5em;
				align-items: top;
				.product-list-title {
					font-size: 1.1em;
					margin: 0 0 0.25em 0;
				}
				.product-list-icon {
					margin: 0 0 0 0.5em; color: #666;
				}
				.product-list-icon:hover {
					color: #333; cursor: pointer;
				}
				.product-list-section-head {
				 	border-top: 1px solid #ccc;
					margin: 0.25em 0 0 0;
					padding: 0.25em 0 0 0;
					color: $dark-grey;
				}
				.product-list-image-wrapper {
					text-align: center;
					img { max-width: 90%; }
				}
			}
			.order-items { font-size: 0.9em; }
		}
	}
}

.detail_supplier {
	margin: 0 0 1em 0;
	display: grid;
    grid-template-columns: 14em 1fr 10em 10em 10em;
	grid-column-gap: 2em;
	align-items: center;
}
.detail-section {
	display: grid;
	grid-template-columns: 1fr 1fr;
	grid-column-gap: 3em;
	textarea { height: 5.66em; }
}
.order-item-wrapper {
	height: 30em;
	overflow-y: scroll;
}
.section-group {
	position: relative;
}
.sub-section {
	margin: 0.9em 0 0 0;
	padding: 0 0 0.9em 0;
	border-bottom: 1px dotted #ccc;
}
.sub-section.no-border {
	border-bottom: 0 none;
}
.shipping-section {
	margin: 1em 0;
	.shipping-details {
		display: grid;
		grid-template-columns: 1fr 1fr 1fr 1fr 2fr 2fr;
		grid-column-gap: 2em;
	}
}
.logbooks-section {
	margin: 0 0 1em 0;
	display: grid;
	grid-template-columns: 20em 1fr;
	grid-column-gap: 3em;
}
.section-mask {
	position: absolute;
	top: 0; left: 0;
	width: 100%; height: 100%;
	background: rgba(255,255,255,0.5);
	cursor: not-allowed;
}
label.checkbox {
	max-width: none;
	width: 100%;
	margin: 0.25em 0;
}
.controls { margin: 1em 0; padding: 1em 0 0 0; border-top: 1px dotted #ccc; }
.new-section {
	display: grid;
	grid-template-columns: 240px 1fr;
	grid-column-gap: 2em;
	.button, select { width: 100%; margin: 0 0 1em; }
}

@media print {
	.list-view { display: block; }
	.detail { height: auto; }
	.main-receive-column { display: none; }
	.detail.receive-inventory {
		display: block;
	}
	.tab-section-title { display: none; }
	.receive-inventory-progress-content {
		position: inherit;
		width: 90%;
		height: auto;
		overflow: auto;
		padding: 0 2em 0 0;
		.two-columns {
			display: grid !important;
			grid-template-columns: 1fr 1fr;
		}
		.product-list-icon { display: none; }
    	.pagebreak { clear: both; page-break-after: always; }
	}
}
</style>
